import { Dayjs } from "dayjs"
import { IThrottleEvent, ThrottleEventStatus } from "./throttleEvent.types"

export class ThrottleEvent implements IThrottleEvent {
  id: number
  communicationName: string
  windowStart: Dayjs
  windowSeconds: number
  maxPerWindow: number
  emailsSent: number
  emailsThrottled: number
  status: ThrottleEventStatus
  resumedBy: string | null
  resumedAt: Dayjs | undefined
  discardedBy: string | null
  discardedAt: Dayjs | undefined

  constructor(
    id: number,
    communicationName: string,
    windowStart: Dayjs,
    windowSeconds: number,
    maxPerWindow: number,
    emailsSent: number,
    emailsThrottled: number,
    status: ThrottleEventStatus,
    resumedBy: string | null,
    resumedAt: Dayjs | undefined,
    discardedBy: string | null,
    discardedAt: Dayjs | undefined,
  ) {
    this.id = id
    this.communicationName = communicationName
    this.windowStart = windowStart
    this.windowSeconds = windowSeconds
    this.maxPerWindow = maxPerWindow
    this.emailsSent = emailsSent
    this.emailsThrottled = emailsThrottled
    this.status = status
    this.resumedBy = resumedBy
    this.resumedAt = resumedAt
    this.discardedBy = discardedBy
    this.discardedAt = discardedAt
  }
}
